<template>
    <div class="m-jx3dat-rank-mini m-jx3dat-rank">
        <h3 class="c-sidebar-right-title">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-bind:class="'u-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#ffa91e"><path d="M324.891 167.266l16.262 94.815L256 217.314l-85.153 44.767 16.262-94.815-68.891-67.16 95.205-13.833L256 0l42.577 86.273 95.205 13.833z"/><path d="M409.944 253.46v87.673L256.9 403.303l-.9-.36-153.944-61.76V253.46L256 315.219z"/><path d="M409.944 362.157v87.673L256.9 512l-.9-.36-153.944-61.76v-87.723L256 423.916z"/></g><g fill="#ff8900"><path d="M341.153 262.081L256 217.314V0l42.577 86.273 95.205 13.833-68.891 67.16zM409.944 253.46v87.673L256.9 403.303l-.9-.36v-87.724zM256 423.916l153.944-61.759v87.673L256.9 512l-.9-.36z"/></g></svg>排行榜
            <span class="u-more" @click="viewRank">查看更多 &raquo;</span>
        </h3>
        <ul class="u-list">
            <li v-for="(item, j) in data" :key="j">
                <a class="u-link" :href="item.pid | postLink">
                    <span class="u-order" :class="highlight(j)">{{ j + 1 }}</span>
                    <span class="u-name">
                        {{ item.author }}
                        <span v-if="item.v != '默认版'">#{{ item.v }}</span>
                    </span>
                    <span class="u-per">
                        <em class="u-count">+ {{ item["7days"] }}</em>
                        <!-- <i
                        class="el-icon-top u-trending"
                        v-if="trending(item) > 0"
                        >{{ (trending(item) * 100).toFixed(2) + "%" }}</i
                    >
                    <i
                        class="el-icon-bottom u-trending"
                        v-if="trending(item) < 0"
                        >{{ (trending(item) * 100).toFixed(2) + "%" }}</i
                    >
                    <span
                        class="u-trending u-trending-keep"
                        v-if="trending(item) == 0"
                        >-</span
                        >-->
                    </span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import { getRank } from "../../service/rank";
import { postLink } from "@jx3box/jx3box-common/js/utils";
export default {
    name: "rank",
    data: function() {
        return {
            data: [],
        };
    },
    computed: {
        client: function() {
            return this.$store.state.client;
        },
    },
    methods: {
        trending: function(item) {
            let trending_1 = (item.before3 - item.before2) / item.before2;
            let trending_2 = (item.before2 - item.yesterday) / item.yesterday;
            let average = (trending_1 + trending_2) / 2;
            return isNaN(average) ? "N/A" : average.toFixed(4);
        },
        viewRank: function() {
            this.$router.push({ name: "jx3dat_rank" });
        },
        highlight: function(i) {
            if (i == 0) {
                return "t1";
            } else if (i == 1) {
                return "t2";
            } else if (i == 2) {
                return "t3";
            }
        },
    },
    filters: {
        postLink: function(pid) {
            return postLink("jx3dat", pid);
        },
    },
    mounted: function() {
        getRank(this.client, 10).then((data) => {
            let _data = [];
            for (let [i, item] of data.entries()) {
                if (item["7days"]) {
                    _data.push(item);
                }
            }
            _data = _data
                .sort((old, now) => {
                    return now["7days"] - old["7days"];
                })
                .slice(0, 10);
            this.data = _data;
        });
    },
    components: {},
};
</script>

<style lang="less">
@import "../../assets/css/rank.less";
</style>
